import { defineComponent as x, ref as L, inject as k, provide as j, toRef as C, computed as g, h as d, withDirectives as H, Transition as D } from "vue";
import { dialogProviderInjectionKey as z } from "./ghl-ui.es1010.js";
import { presetProps as I, presetPropsKeys as T } from "./ghl-ui.es1011.js";
import U from "./ghl-ui.es1012.js";
import { modalProviderInjectionKey as _, modalInjectionKey as K } from "./ghl-ui.es1013.js";
import V from "./ghl-ui.es1014.js";
import { warnOnce as f } from "./ghl-ui.es819.js";
import $ from "./ghl-ui.es820.js";
import y from "./ghl-ui.es821.js";
import W from "./ghl-ui.es685.js";
import q from "./ghl-ui.es683.js";
import G from "./ghl-ui.es687.js";
import { useIsComposing as J } from "./ghl-ui.es952.js";
import { useThemeClass as Q } from "./ghl-ui.es823.js";
import { keep as X } from "./ghl-ui.es889.js";
import Y from "./ghl-ui.es734.js";
import Z from "./ghl-ui.es693.js";
import ee from "./ghl-ui.es1015.js";
import { call as u } from "./ghl-ui.es860.js";
import { getPreciseEventTarget as oe } from "./ghl-ui.es875.js";
import { eventEffectNotPerformed as te } from "./ghl-ui.es934.js";
const ne = Object.assign(Object.assign(Object.assign(Object.assign({}, y.props), {
  show: Boolean,
  unstableShowMask: {
    type: Boolean,
    default: !0
  },
  maskClosable: {
    type: Boolean,
    default: !0
  },
  preset: String,
  to: [String, Object],
  displayDirective: {
    type: String,
    default: "if"
  },
  transformOrigin: {
    type: String,
    default: "mouse"
  },
  zIndex: Number,
  autoFocus: {
    type: Boolean,
    default: !0
  },
  trapFocus: {
    type: Boolean,
    default: !0
  },
  closeOnEsc: {
    type: Boolean,
    default: !0
  },
  blockScroll: {
    type: Boolean,
    default: !0
  }
}), I), {
  // events
  onEsc: Function,
  "onUpdate:show": [Function, Array],
  onUpdateShow: [Function, Array],
  onAfterEnter: Function,
  onBeforeLeave: Function,
  onAfterLeave: Function,
  onClose: Function,
  onPositiveClick: Function,
  onNegativeClick: Function,
  onMaskClick: Function,
  // private
  internalDialog: Boolean,
  internalModal: Boolean,
  internalAppear: {
    type: Boolean,
    default: void 0
  },
  // deprecated
  overlayStyle: [String, Object],
  onBeforeHide: Function,
  onAfterHide: Function,
  onHide: Function
}), Fe = x({
  name: "Modal",
  inheritAttrs: !1,
  props: ne,
  setup(o) {
    process.env.NODE_ENV !== "production" && (o.onHide && f("modal", "`on-hide` is deprecated."), o.onAfterHide && f("modal", "`on-after-hide` is deprecated, please use `on-after-leave` instead."), o.onBeforeHide && f("modal", "`on-before-hide` is deprecated, please use `on-before-leave` instead."), o.overlayStyle && f("modal", "`overlay-style` is deprecated, please use `style` instead."));
    const s = L(null), {
      mergedClsPrefixRef: a,
      namespaceRef: l,
      inlineThemeDisabled: m
    } = $(o), h = y("Modal", "-modal", V, ee, o, a), P = W(64), b = q(), v = G(), B = o.internalDialog ? k(z, null) : null, R = o.internalModal ? k(_, null) : null, F = J();
    function i(e) {
      const {
        onUpdateShow: t,
        "onUpdate:show": n,
        onHide: c
      } = o;
      t && u(t, e), n && u(n, e), c && !e && c(e);
    }
    function S() {
      const {
        onClose: e
      } = o;
      e ? Promise.resolve(e()).then((t) => {
        t !== !1 && i(!1);
      }) : i(!1);
    }
    function w() {
      const {
        onPositiveClick: e
      } = o;
      e ? Promise.resolve(e()).then((t) => {
        t !== !1 && i(!1);
      }) : i(!1);
    }
    function A() {
      const {
        onNegativeClick: e
      } = o;
      e ? Promise.resolve(e()).then((t) => {
        t !== !1 && i(!1);
      }) : i(!1);
    }
    function M() {
      const {
        onBeforeLeave: e,
        onBeforeHide: t
      } = o;
      e && u(e), t && t();
    }
    function E() {
      const {
        onAfterLeave: e,
        onAfterHide: t
      } = o;
      e && u(e), t && t();
    }
    function O(e) {
      var t;
      const {
        onMaskClick: n
      } = o;
      n && n(e), o.maskClosable && !((t = s.value) === null || t === void 0) && t.contains(oe(e)) && i(!1);
    }
    function N(e) {
      var t;
      (t = o.onEsc) === null || t === void 0 || t.call(o), o.show && o.closeOnEsc && te(e) && !F.value && i(!1);
    }
    j(K, {
      getMousePosition: () => {
        const e = B || R;
        if (e) {
          const {
            clickedRef: t,
            clickedPositionRef: n
          } = e;
          if (t.value && n.value)
            return n.value;
        }
        return P.value ? b.value : null;
      },
      mergedClsPrefixRef: a,
      mergedThemeRef: h,
      isMountedRef: v,
      appearRef: C(o, "internalAppear"),
      transformOriginRef: C(o, "transformOrigin")
    });
    const p = g(() => {
      const {
        common: {
          cubicBezierEaseOut: e
        },
        self: {
          boxShadow: t,
          color: n,
          textColor: c
        }
      } = h.value;
      return {
        "--n-bezier-ease-out": e,
        "--n-box-shadow": t,
        "--n-color": n,
        "--n-text-color": c
      };
    }), r = m ? Q("theme-class", void 0, p, o) : void 0;
    return {
      mergedClsPrefix: a,
      namespace: l,
      isMounted: v,
      containerRef: s,
      presetProps: g(() => X(o, T)),
      handleEsc: N,
      handleAfterLeave: E,
      handleClickoutside: O,
      handleBeforeLeave: M,
      doUpdateShow: i,
      handleNegativeClick: A,
      handlePositiveClick: w,
      handleCloseClick: S,
      cssVars: m ? void 0 : p,
      themeClass: r == null ? void 0 : r.themeClass,
      onRender: r == null ? void 0 : r.onRender
    };
  },
  render() {
    const {
      mergedClsPrefix: o
    } = this;
    return d(Y, {
      to: this.to,
      show: this.show
    }, {
      default: () => {
        var s;
        (s = this.onRender) === null || s === void 0 || s.call(this);
        const {
          unstableShowMask: a
        } = this;
        return H(d("div", {
          role: "none",
          ref: "containerRef",
          class: [`${o}-modal-container`, this.themeClass, this.namespace],
          style: this.cssVars
        }, d(U, Object.assign({
          style: this.overlayStyle
        }, this.$attrs, {
          ref: "bodyWrapper",
          displayDirective: this.displayDirective,
          show: this.show,
          preset: this.preset,
          autoFocus: this.autoFocus,
          trapFocus: this.trapFocus,
          blockScroll: this.blockScroll
        }, this.presetProps, {
          onEsc: this.handleEsc,
          onClose: this.handleCloseClick,
          onNegativeClick: this.handleNegativeClick,
          onPositiveClick: this.handlePositiveClick,
          onBeforeLeave: this.handleBeforeLeave,
          onAfterEnter: this.onAfterEnter,
          onAfterLeave: this.handleAfterLeave,
          onClickoutside: a ? void 0 : this.handleClickoutside,
          renderMask: a ? () => {
            var l;
            return d(D, {
              name: "fade-in-transition",
              key: "mask",
              appear: (l = this.internalAppear) !== null && l !== void 0 ? l : this.isMounted
            }, {
              default: () => this.show ? d("div", {
                "aria-hidden": !0,
                ref: "containerRef",
                class: `${o}-modal-mask`,
                onClick: this.handleClickoutside
              }) : null
            });
          } : void 0
        }), this.$slots)), [[Z, {
          zIndex: this.zIndex,
          enabled: this.show
        }]]);
      }
    });
  }
});
export {
  Fe as default,
  ne as modalProps
};
